module.exports = __webpack_public_path__ + "img/nature-58.5745490d.jpg";